import React from 'react';

export const FlagCz = () => {
  return (
    <svg width="51" height="34" viewBox="0 0 51 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group">
        <path
          id="Vector"
          d="M51 17.0048V31.312C50.9974 32.0241 50.7011 32.7064 50.1757 33.2099C49.6503 33.7135 48.9384 33.9975 48.1954 34H2.8046C2.06158 33.9975 1.34974 33.7135 0.824344 33.2099C0.298947 32.7064 0.00262091 32.0241 0 31.312L0 17.0048H51Z"
          fill="#D7141A"
        />
        <path
          id="Vector_2"
          d="M51 17.0048H0V2.68797C0.00262091 1.97585 0.298947 1.29361 0.824344 0.790064C1.34974 0.286515 2.06158 0.00251192 2.8046 0L48.1954 0C48.9384 0.00251192 49.6503 0.286515 50.1757 0.790064C50.7011 1.29361 50.9974 1.97585 51 2.68797V17.0048Z"
          fill="white"
        />
        <path
          id="Vector_3"
          d="M25.5 17.0048L0.566888 1.06757C0.208853 1.52509 0 2.07794 0 2.68798V31.312C0 31.9221 0.208853 32.4844 0.566888 32.9324L25.5 17.0048Z"
          fill="#11457E"
        />
      </g>
    </svg>
  );
};
